import { render } from "./FormEntity.vue?vue&type=template&id=5aa8ca14"
import script from "./FormEntity.vue?vue&type=script&lang=js"
export * from "./FormEntity.vue?vue&type=script&lang=js"
script.render = render

export default script